export default __webpack_public_path__ + "static/media/rank_bg_sp.f0c77d53.jpg";